import { z } from 'zod/v4';

import { MemoryEntityKindSchema } from './memory.schema';
import { LLMBackendSchema } from './reading.schema';
import { OrientationSchema, ReadingModeSchema } from './tarot.schema';
import { ReadingSchema } from './reading.schema';

export const DBReadingSchema = z.object({
  id: z.string().min(1),
  user_id: z.string().min(1),
  spread_id: z.string().min(1),
  spread_name: z.string().min(1),
  question: z.string().min(1),
  intent: z.string().min(1).nullable(),
  mode: ReadingModeSchema,
  llm_backend: LLMBackendSchema,
  llm_response: z.string().min(1).nullable(),
  interpretation_json: z.string().min(1),
  entropy_audit_json: z.string().min(1),
  notes: z.string(),
  tags_json: z.string(),
  is_favorite: z.number().int().min(0).max(1),
  created_at: z.string().min(1),
  updated_at: z.string().min(1),
});

export const DBReadingCardSchema = z.object({
  id: z.string().min(1),
  reading_id: z.string().min(1),
  card_id: z.number().int().nonnegative(),
  card_name: z.string().min(1),
  position_index: z.number().int().nonnegative(),
  position_name: z.string().min(1),
  orientation: OrientationSchema,
  draw_index: z.number().int().nonnegative(),
});

export const DBMemoryEntitySchema = z.object({
  id: z.string().min(1),
  user_id: z.string().min(1),
  kind: MemoryEntityKindSchema,
  label: z.string().min(1),
  strength: z.number(),
  sigma: z.number(),
  occurrences: z.number().int().nonnegative(),
  metadata_json: z.string().min(1),
  first_seen: z.string().min(1),
  last_seen: z.string().min(1),
});

export const BrowserReadingCacheSchema = z.object({
  id: z.string().min(1),
  reading: ReadingSchema,
  sync_status: z.enum(['local-only', 'queued', 'synced', 'error']),
  updated_at: z.string().min(1),
});

export const BrowserSyncJobSchema = z.object({
  id: z.string().min(1),
  type: z.enum(['save_reading', 'save_note', 'sync_settings']),
  payload: z.record(z.string(), z.unknown()),
  status: z.enum(['queued', 'running', 'done', 'error']),
  retry_count: z.number().int().nonnegative(),
  created_at: z.string().min(1),
  updated_at: z.string().min(1),
});
